import { OutletListItem, OutletState } from '@ancon/wildcat-types'
import clsx from 'clsx'
import OutletBannerPlaceholder from '@ancon/wildcat-ui/shared/static/placeholders/outlet-card-banner.svg'

import OptimizedImage from '../../../app/components/OptmizedImage'

import OutletCardOutletStatus from './OutletCardOutletStatus'
import styles from './OutletCardBanner.module.scss'

interface OutletCardBannerProps {
  outlet: OutletListItem
}

export default function OutletCardBanner({ outlet }: OutletCardBannerProps) {
  const { name, imageId, logoId, modified, state } = outlet
  const isOutletClosed = state !== OutletState.Opened

  return (
    <div className={styles.bannerContainer}>
      <OptimizedImage
        mediaId={imageId}
        modified={modified}
        src={OutletBannerPlaceholder}
        className={styles.bannerImage}
        width={300}
        height={150}
        alt={name}
      />
      <div
        className={clsx(styles.bannerOverlay, {
          [styles.outletClosed]: isOutletClosed,
        })}
      />
      <div className={styles.logoContainer}>
        <OptimizedImage
          mediaId={logoId}
          modified={modified}
          src="/images/outlet-logo-placeholder.jpg"
          width={60}
          height={60}
          alt={name}
          className={styles.logoImage}
        />
        <OutletCardOutletStatus outlet={outlet} />
      </div>
    </div>
  )
}
